import React from 'react';
import PhysicalNotesLayout from '@layout/PhysicalNotesLayout';
import PhysicalNotes from '@cont/PhysicalNotes/PhysicalNotes';
import setupInitialProps from '@utils/setupInitialProps';
import PageReduxProvider from '@cont/App/PageReduxProviderWrapper';

const PhysicalNotesHomePage = () => <PhysicalNotes />;

PhysicalNotesHomePage.Layout = PhysicalNotesLayout;

PhysicalNotesHomePage.pageInfo = {
  isMWebSupported: true,
  layoutOptions: {
    hideIntercom: true,
    hideFreshbot: true,
    disableDarkMode: true
  }
};

PhysicalNotesHomePage.getInitialProps = setupInitialProps(
  null,
  PhysicalNotesHomePage.pageInfo
);

export default PhysicalNotesHomePage;
PhysicalNotesHomePage.Wrapper = PageReduxProvider;
